import styled from 'styled-components'

import type { OrderPopoverProps } from './types'

type ContainerProps = Pick<OrderPopoverProps, '$padding'>

const getContainerPadding = ({ $padding }: ContainerProps) => {
  if ($padding === 'small') {
    return 12
  }
  if ($padding === 'medium') {
    return 20
  }
}

export const Container = styled.div<ContainerProps>`
  padding: ${getContainerPadding}px;
`

export const Title = styled.div`
  font-weight: 600;
  margin-bottom: 12px;
`

export const TimelineContainer = styled.div`
  padding-right: 8px;
`

export const EmptyNotice = styled.div`
  font-size: 14px;
`
